import React from "react";
import { Link } from "react-router-dom";

export default function MerchantNotFoundPage() {
  return (
    <div className="merchant-card merchant-empty-state">
      <div className="merchant-page-title">Page not found</div>
      <div className="merchant-page-subtitle">
        This merchant page has not been mapped yet. Head back to the dashboard.
      </div>
      <Link className="merchant-button merchant-button-primary" to="/dashboard">
        Back to dashboard
      </Link>
    </div>
  );
}
